/**
 * Visual emphasis tiers for raw terraform plan-log lines, shared by the
 * homepage haystack strip and the demo raw-log drawer so both surfaces
 * highlight the same needles.
 */
export type PlanLogTone = "muted" | "marker" | "needle";

export function planLogLineTone(line: string): PlanLogTone {
  if (/^ {2}# \S+ must be replaced$/.test(line) || line.includes("# forces replacement")) {
    return "needle";
  }
  if (/^ {2}# \S+ will be (created|destroyed|updated in-place)$/.test(line)) {
    return "marker";
  }
  return "muted";
}

/** Index of the first needle-tone line, or the first marker line when no
 * needle exists, or -1. Used to auto-scroll log views to the interesting part. */
export function firstHighlightIndex(lines: readonly string[]): number {
  let firstMarker = -1;
  for (let i = 0; i < lines.length; i += 1) {
    const tone = planLogLineTone(lines[i]);
    if (tone === "needle") return i;
    if (tone === "marker" && firstMarker === -1) firstMarker = i;
  }
  return firstMarker;
}
